<template>
  <div class="common-modal-wrap">
    <!-- mobile modal-->
    <div
      v-if="isMobile"
      class="bg-white w-full mx-2 h-[70vh] rounded-lg overflow-hidden flex flex-col"
    >
      <!-- modal header-->
      <div class="bg-gray-200 p-4 flex justify-between items-center">
        <h2 class="text-md font-bold">매수 설정</h2>
        <button @click="$emit('modal-close')" class="text-gray-500">
          닫기
        </button>
      </div>
      <!-- modal user asset -->
      <div class="mobile-modal-flex-item-group">
        <div class="mobile-modal-flex-item">
          <span><b>코인명</b></span>
          <span>{{ coinName }} ({{ symbolConfig.leverage }}X)</span>
        </div>
        <div class="mobile-modal-flex-item">
          <span><b>거래 가능 자산</b></span>
          <span
            >{{ ASSET_USDT.availableBalance.toLocaleString("en-US") }}
            <small>USDT</small>
          </span>
        </div>

        <div class="mobile-modal-flex-item mb-2">
          <span><b>현재가</b></span>
          <span>{{ markPrice }} <small>USDT</small></span>
        </div>
        <div class="mobile-modal-flex-item">
          <span><b>최소 코인 수량</b></span>
          <span>소수점 {{ symbolConfig?.quantityPrecision }} 자리</span>
        </div>
        <div class="mobile-modal-flex-item">
          <span><b>거래 최소 USDT</b></span>
          <span
            >{{ symbolConfig?.minNotional.toLocaleString("en-US") }}
            <small>USDT</small></span
          >
        </div>
        <div class="mobile-modal-flex-item">
          <span><b>심볼 증감 단위</b></span>
          <span>{{ symbolConfig?.marketStepSize }}</span>
        </div>
      </div>
      <!-- 사용자 주문 입력 -->
      <!-- 포지션 정보가 없는 경우, 진입 주문 화면 노출 -->
      <div class="flex-1 px-4 py-2 overflow-y-auto" v-if="!isExist">
        <div class="mb-4">
          <div class="flex items-start space-y-2 flex-col">
            <label class="font-semibold block">포지션 진입</label>
            <label class="text-red-400 text-xs text-left break-keep">
              해당 코인의 자산이 없습니다. 해당 심볼의 포지션 진입을 해주시기
              바랍니다.
            </label>
          </div>
        </div>
        <span class="text-left text-red-400 text-xs">{{ validUsdt }}</span>
      </div>
      <div class="p-4">
        <button
          @click="saveReq"
          class="bg-blue-500 text-white w-full py-2 rounded"
        >
          저장
        </button>
      </div>
    </div>

    <!-- pc modal-->
    <div class="pc-modal-content" v-else>
      <div class="pc-modal-header">
        <h2 class="text-lg font-bold">매수 설정</h2>
        <button @click="$emit('modal-close')" class="text-gray-500">
          닫기
        </button>
      </div>
      <!-- coin basic/config info-->
      <div class="pc-modal-description-wrap">
        <p class="text-black font-bold">{{ coinName }} 기본 정보</p>
        <div class="mt-1">
          <ul class="pc-modal-description-item-group">
            <li class="pc-modal-description-item">
              <label
                >최소 거래 USDT 단위 (소수점)
                <button type="button" class="tooltip">
                  &#9432;
                  <span class="tooltip-text tooltip-top"
                    >거래에 사용할 최소 USDT 단위를 의미합니다.</span
                  >
                </button>
              </label>
              <p class="font-bold">
                소수점 {{ symbolConfig?.pricePrecision }} 자리
              </p>
            </li>
            <li class="pc-modal-description-item">
              <label
                >최소 수량 단위 (소수점)
                <button type="button" class="tooltip">
                  &#9432;
                  <span class="tooltip-text tooltip-top"
                    >거래에 사용할 최소 코인의 수량 소수점 단위를
                    의미합니다.</span
                  >
                </button>
              </label>
              <p class="font-bold">
                소수점 {{ symbolConfig?.quantityPrecision }} 자리
              </p>
            </li>
            <li class="pc-modal-description-item">
              <label
                >거래 진입 최소 USDT
                <button type="button" class="tooltip">
                  &#9432;
                  <span class="tooltip-text tooltip-top"
                    >주문 가능한 USDT의 최소 금액을 의미합니다.(레버리지
                    포함)</span
                  >
                </button>
              </label>
              <p class="font-bold">{{ symbolConfig?.minNotional }}USDT</p>
            </li>
            <li class="pc-modal-description-item">
              <label
                >심볼 증감 단위
                <button type="button" class="tooltip">
                  &#9432;
                  <span class="tooltip-text tooltip-top"
                    >주문 가능한 코인의 증,감 단위를 의미합니다.
                  </span>
                </button>
              </label>
              <p class="font-bold">{{ symbolConfig?.marketStepSize }}</p>
            </li>
            <li class="pc-modal-description-item">
              <label>레버리지</label>
              <p class="font-bold">({{ symbolConfig?.leverage }} 배)</p>
            </li>
            <li class="pc-modal-description-item">
              <label>현재가</label>
              <p class="font-bold">{{ Number(markPrice) }} USDT</p>
            </li>
            <li class="pc-modal-description-item">
              <label>거래 가능 자산</label>
              <p class="font-bold">
                {{ ASSET_USDT.availableBalance.toLocaleString("en-US") }} USDT
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div class="flex-1 p-4 overflow-y-auto">
        <div class="mb-4">
          <div>
            <div class="modal-tab-header">
              <button
                type="button"
                class="tab-head"
                :class="{ 'tab-active': buyConfigTab.curIndex === 0 }"
                @click="toggleTab(0)"
              >
                <label>포지션 진입</label>
              </button>
              <button
                v-if="buyConfig != null && buyConfig.config != null"
                type="button"
                class="tab-head"
                :class="{ 'tab-active': buyConfigTab.curIndex === 1 }"
                @click="toggleTab(1)"
              >
                <label>데이터 리스트</label>
              </button>
            </div>
            <div class="modal-tab-items">
              <div
                class="modal-tab-item data-config"
                v-if="buyConfigTab.curIndex === 0"
              >
                <!-- tab 0-->
                <div class="buy-config-wrap">
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'포지션 진입 자산'"
                      v-model="initAmt"
                      :suffix="'USDT'"
                      :tooltip="'추가 매수 및 마틴 비율의 기준이 됩니다.'"
                    />
                    <p class="text-right text-gray-400">
                      예상 코인 수량 :
                      {{ calcPredictInitSymbolSize.inputSize }}
                      {{ coinName.replaceAll("USDT", "") }}
                    </p>
                    <p
                      class="text-right text-gray-400"
                      :class="{
                        'text-gray-400': validateTradeInit.predictPriceValid,
                        'text-red-400': !validateTradeInit.predictPriceValid,
                      }"
                    >
                      소수점 처리 후 : {{ calcPredictInitSymbolSize.floorSize }}
                      {{ coinName.replaceAll("USDT", "") }}
                    </p>
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'목표 수익(수익 실현)'"
                      v-model="takeProfitPercent"
                      :suffix="'%'"
                      :tooltip="'원금 기준'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'추가 매수 횟수 제한'"
                      v-model="addBuyLimit"
                      :suffix="'회'"
                      :tooltip="'물타기 허용 횟수'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'강제 매도 (손절)'"
                      v-model="forceCellPercent"
                      :suffix="'%'"
                      :tooltip="'원금 기준'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'추가 매수 기준'"
                      v-model="buyTriggerPercent"
                      :suffix="'%'"
                      :tooltip="'포지션 진입시 코인 가격 기준. 입력한 값 만큼 하락시 n회 추가 매수'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'포지션 진입 자산 상한'"
                      v-model="buyUsdtOverLimit"
                      :suffix="'USDT'"
                      :tooltip="'이번 매매에 사용할 최대 금액'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'추가 매수 진입 자산 비율'"
                      v-model="buyUsdtPercent"
                      :suffix="'%'"
                      :tooltip="'이전 포지션 진입 자산을 모두 합친 평단 기준'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'익절시 재진입 간격(분 단위)'"
                      :suffix="'분'"
                      :tooltip="'익절시 포지션 재 진입시 시간 간격'"
                      v-model="retryForceMin"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'추가 매수 중지'"
                      v-model="buyStopPercent"
                      :suffix="'%'"
                      :tooltip="'포지션에 진입했던 시점의 코인 가격 기준'"
                    />
                  </div>
                  <div class="buy-config-item">
                    <InputField
                      :formLabel="'손절시 재진입 간격(분 단위)'"
                      v-model="retryLiqMin"
                      :suffix="'분'"
                      :tooltip="'손절시 포지션 재 진입 시간 간격'"
                    />
                  </div>
                </div>
              </div>
              <div
                class="modal-tab-item data-list"
                v-if="buyConfigTab.curIndex === 1"
              >
                <!-- tab 1-->
                <ul>
                  <li
                    v-for="(item, index) in buyConfig.list"
                    :key="item + '_' + index"
                    :class="parseDataItemStats(item.reqStats)"
                  >
                    <div class="data-list-item">
                      <p>타입</p>
                      <span
                        >{{ parseItemType(item.itemType) }}
                        <small
                          >({{
                            parseReqStats(item.reqStats, item.execMsg)
                          }})</small
                        ></span
                      >
                    </div>
                    <div class="data-list-item">
                      <p>코인 가격</p>
                      <span>{{ parseTriggerPrice(item) }}</span>
                    </div>
                    <div class="data-list-item">
                      <p>코인 수량</p>
                      <span>{{ item.symbolSize }}</span>
                    </div>
                    <div class="data-list-item">
                      <p>사용/사용 예정 USDT</p>
                      <span
                        >{{ cutNumberFloorUSDT(item.usdtAmt) }}
                        <small>USDT</small></span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- <span class="w-full text-red-400 text-right">{{ validUsdt }}</span> -->
      </div>

      <div class="p-4">
        <button
          @click="saveReq"
          class="bg-blue-500 text-white w-full py-2 rounded"
          :disabled="!updatable"
        >
          {{
            updatable ? "저장" : "매수 중지 혹은 매도 후 수정할 수 있습니다."
          }}
        </button>
      </div>
      <AxiosLoading v-if="isLoading" :size="40" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import InputField from "../InputField.vue";
import AxiosLoading from "../spinner/AxiosLoading.vue";
import { storeName } from "@/global/variable";

const assetStore = "assetStore";
export default defineComponent({
  name: "ModalPopup",
  components: { InputField, AxiosLoading },
  props: {
    isMobile: Boolean,
    coinName: String,
    buyConfig: Object,
    updatable: Boolean,
  },

  setup() {
    let initAmt = ref(0);
    let addBuyLimit = ref(0);
    let buyTriggerPercent = ref(0);
    let buyUsdtPercent = ref(0);
    let buyStopPercent = ref(0);
    let buyUsdtOverLimit = ref(0);
    let retryBuyUsdtOverLimit = ref(0);
    let takeProfitPercent = ref(0);
    let forceCellPercent = ref(0);
    let retryForceMin = ref(0);
    let retryLiqMin = ref(0);

    return {
      initAmt, // 포지션 진입 자산
      addBuyLimit, // 추가 매수 횟수 제한
      buyTriggerPercent, // 추가 매수 기준
      buyUsdtPercent, // 추가 매수 진입 자산 비율
      buyStopPercent, // 추가 매수 중지
      buyUsdtOverLimit, // 포지션 진입 자산 상한
      retryBuyUsdtOverLimit, // 상기동일
      takeProfitPercent, // 목표 수익
      forceCellPercent, // 강제 매도
      retryForceMin, // 손절 재진입 인터벌 (분)
      retryLiqMin, // 청산시 재진입 인터벌 (분)
    };
  },

  data() {
    return {
      // 코인 기본 정보 데이터
      symbolConfig: {
        leverage: null,
        pricePrecision: null,
        quantityPrecision: null,
        minNotional: null,
        marketStepSize: null,
      },
      /**
       * buy config property
       */
      buyConfigInput: {
        tradeId: null,
        symbol: null, // 코인 명
        positionSide: null, // 포지션
        isBuyStop: false, // 매수 중지 상태인지
        isForceSell: false, // 강제 매도 되었는지
      },
      buyConfigTab: {
        curIndex: 0,
        items: [
          { index: 0, label: "포지션 진입" },
          { index: 1, label: "매수 리스트" },
        ],
      },
      predictSymbolSize: 0,
      isLoading: false,
    };
  },
  created() {
    this.symbolName = this.coinName;
    this.symbol = this.coinName.replace("USDT", "");
  },
  mounted() {
    const _symbolConfig = this.$store.getters[`${assetStore}/ASSET_CONFIG`](
      this.symbolName
    );
    this.symbolConfig = {
      ...this.symbolConfig,
      ..._symbolConfig,
    };
    this.buyConfigInput.symbol = this.symbolName;

    if (
      this.buyConfig != null &&
      this.buyConfig.config != null &&
      this.buyConfig.list.length > 0
    ) {
      this.buyConfigInput.tradeId = this.buyConfig.config.tradeId;

      this.initAmt = ref(this.buyConfig.config.positionInitAmt); // 포지션 진입 자산
      this.addBuyLimit = ref(this.buyConfig.config.addBuyLimit); // 추가 매수 횟수 제한
      this.buyTriggerPercent = ref(this.buyConfig.config.buyTriggerPercent); // 추가 매수 기준
      this.buyUsdtPercent = ref(this.buyConfig.config.buyUsdtPercent); // 추가 매수 진입 자산 비율
      this.buyStopPercent = ref(this.buyConfig.config.buyStopPercent); // 추가 매수 중지
      this.buyUsdtOverLimit = ref(this.buyConfig.config.buyUsdtOverLimit); // 포지션 진입 자산 상한
      this.retryBuyUsdtOverLimit = ref(
        this.buyConfig.config.retryBuyUsdtOverLimit
      ); // 상기동일
      this.takeProfitPercent = ref(this.buyConfig.config.takeProfitPercent); // 목표 수익
      this.forceCellPercent = ref(this.buyConfig.config.forceCellPercent); // 강제 매도
      this.retryForceMin = ref(this.buyConfig.config.retryForceMin);
      this.retryLiqMin = ref(this.buyConfig.config.retryLiqMin);
    }
  },
  unmounted() {
    this.symbolConfig = {
      leverage: null,
      pricePrecision: null,
      quantityPrecision: null,
      minNotional: null,
      marketStepSize: null,
    };
    this.buyConfigInput = {
      tradeId: null,
      symbol: null, // 코인 명
      positionSide: null, // 포지션

      isBuyStop: false, // 매수 중지 상태인지
      isForceSell: false, // 강제 매도 되었는지
    };
  },
  computed: {
    ...mapGetters(storeName.asset, ["ASSET_USDT"]),
    ...mapGetters(storeName.core, ["GT_IS_LONG"]),
    tpslDisabled: function () {
      if (this.buyConfigInput.tradeId == null) return false;
      if (this.buyConfig.config.isBuyStop) return false;
      if (this.buyConfig.config.isEndTrade) return false;
      return true;
    },
    // 현재가 가져오기
    markPrice: function () {
      return this.$store.getters[`markPriceStore/${this.symbol}`];
    },
    // 코인별 기본 정보

    validUsdt: function () {
      if (this.positionInit.usdtPrice === "") {
        return "";
      } else {
        if (
          Number(this.symbolConfig.minNotional) > this.positionInit.usdtPrice
        ) {
          return "거래 기준 금액은 '거래 최소 USDT' 보다 커야합니다";
        } else {
          return "";
        }
      }
    },

    calcPredictInitSymbolSize: function () {
      let inputSize = 0;
      let floorSize = 0;
      const inputLimitFloor = 8;
      if (
        this.symbolConfig != null &&
        this.symbolConfig.quantityPrecision != null
      ) {
        const calcedSize =
          (this.initAmt * this.symbolConfig.leverage) / this.markPrice;
        inputSize =
          Math.floor(calcedSize * Math.pow(10, inputLimitFloor)) /
          Math.pow(10, inputLimitFloor);
        floorSize =
          Math.floor(
            calcedSize * Math.pow(10, this.symbolConfig.quantityPrecision)
          ) / Math.pow(10, this.symbolConfig.quantityPrecision);
      }

      return {
        inputSize,
        floorSize,
      };
    },

    validateTradeInit: function () {
      let flag = false;
      let predictPriceValid = false;
      if (Number(this.calcPredictInitSymbolSize.floorSize) > 0) {
        flag = true;
        predictPriceValid = true;
      } else {
        flag = false;
        predictPriceValid = false;
      }
      return {
        flag,
        predictPriceValid,
      };
    },
  },
  methods: {
    ...mapActions(`${storeName.buyConfig}`, [
      "AC_SAVE_BUY_CONFIG",
      "AC_UPDATE_BUY_CONFIG",
    ]),
    ...mapMutations(`${storeName.manual}`, ["MU_UPDATE_M_SINGLE"]),
    openLoading() {
      this.isLoading = true;
    },
    closeLoading() {
      this.isLoading = false;
    },
    toggleTab(index) {
      this.buyConfigTab.curIndex = index;
    },
    parseItemType(itemType) {
      return itemType === "INIT" ? "포지션 진입" : "물타기";
    },
    parseReqStats(reqStats, execMsg) {
      let returnStr;
      switch (reqStats) {
        case "SUCCESS":
          returnStr = "체결완료";
          break;
        case "READY":
          returnStr = "주문 대기";
          break;
        case "PENDING":
          returnStr = "처리중";
          break;
        case "CANCELED":
          returnStr = "주문 취소";
          break;
        case "PARTIAL":
          returnStr = "부분 체결";
          break;
        case "FAILED":
          returnStr = this.parseErrorMsg(execMsg);

          break;
      }
      return returnStr;
    },
    parseTriggerPrice(item) {
      return item.itemType === "INIT"
        ? this.cutNumberFloorUSDT(item.symbolBinancePrice)
        : this.cutNumberFloorUSDT(item.triggerPrice);
    },
    parseDataItemStats(reqStats) {
      let styleStr;
      switch (reqStats) {
        case "SUCCESS":
          styleStr = "item-success";
          break;
        case "READY":
          styleStr = "item-ready";
          break;
        case "PENDING":
          styleStr = "item-pending";
          break;
        case "PARTIAL":
          styleStr = "item-success";
          break;
        case "FAILED":
          styleStr = "item-failed";
          break;
      }

      return styleStr;
    },

    /**
     * usdt 자리수 커팅
     * @param usdt {Number} 원래 값

     * 파라미터로 넘어온 소수점 제한 자리수에 맞춰서 usdt 를 변환함.
     *
     */
    cutNumberFloorUSDT(usdt) {
      const limit = this.symbolConfig.quantityPrecision;
      if (limit == null || usdt == null) return usdt;

      return Math.floor(usdt * Math.pow(10, limit)) / Math.pow(10, limit);
    },

    parseErrorMsg(errorMsg) {
      let msg;
      switch (errorMsg) {
        case "OVER_USDT":
          msg = "자산 상한 초과";
          break;
        case "COUNTERPARTY":
          msg = "유동 금액 불충분";
          break;
        case "NOT_ENOUGH":
          msg = "잔고 부족";
          break;
        case "Margin is insufficient.":
          msg = "증거금 불충분";
          break;
        case "QUANTITY_ZERO":
          msg = "코인 수량 조건 미달";
          break;
        default:
          msg = "오류";
          break;
      }
      return msg;
    },

    /**
     * 매수 설정 저장 클릭시
     */
    async saveReq() {
      if (!confirm("매수 설정을 저장하시겠습니까?")) return;
      this.openLoading();

      const postForm = {
        ...this.buyConfigInput,
        initAmt: this.initAmt,
        addBuyLimit: this.addBuyLimit,
        buyTriggerPercent: this.buyTriggerPercent,
        buyUsdtPercent: this.buyUsdtPercent,
        buyStopPercent: this.buyStopPercent,
        buyUsdtOverLimit: this.buyUsdtOverLimit,
        retryBuyUsdtOverLimit: this.retryBuyUsdtOverLimit,
        takeProfitPercent: this.takeProfitPercent,
        forceCellPercent: this.forceCellPercent,
        positionSide: this.GT_IS_LONG ? "LONG" : "SHORT",
        tradeConfigId: this.buyConfigInput.tradeId,
        retryForceMin: this.retryForceMin,
        retryLiqMin: this.retryLiqMin,
      };

      console.log(postForm);
      // this.closeLoading();
      if (this.buyConfigInput.tradeId != null) {
        // 수정

        await this.AC_UPDATE_BUY_CONFIG(postForm);
        this.closeLoading();
      } else {
        // 신규 저장

        const apiResult = await this.AC_SAVE_BUY_CONFIG(postForm);

        this.closeLoading();
        if (apiResult.flag) {
          //   this.$store.dispatch(`{${storeName.manual}/MU_UPDATE_M_SINGLE`, {
          //   position: cv.positionSide,
          //   symbol: cv.symbol,
          //   stop: isStop,
          // });
          this.MU_UPDATE_M_SINGLE({
            position: postForm.positionSide.toLowerCase(),
            symbol: this.symbolName,
            isStop: true,
          });
          alert("성공적으로 등록되었습니다.");
        } else {
          alert("요청을 처리하는 도중 오류가 발생했습니다.");
        }
      }
      this.$emit("modal-close");
    },
  },
});
</script>
